import styled from "styled-components";

export const Wrapper = styled.div<{ $hidden: boolean }>`
    position: sticky;
    top: 0;
    z-index: 100;
    transform: translateY(${({ $hidden }) => ($hidden ? "-100%" : "0")}) translateZ(0);
    transition: transform 0.15s ${({ $hidden }) => ($hidden ? "ease-in" : "ease-out")};
`;
